import React from 'react';

import {
  useDeleteFinancialResult,
  useApproveFinancialResult,
} from 'scenes/FinancialResults/data/mutations';
import Permissions from '@gogame/permissions';
import {
  Action,
  Actions as UIActions,
  DeleteIcon,
  DoneIcon,
} from '@gogame/components';

export const ActionsOnDraft = ({ data, actions, onDelete }) => {
  const [deleteFinancialResult] = useDeleteFinancialResult({
    showDraftAlert: true,
  });

  const [approveFinancialResult] = useApproveFinancialResult({
    showDraftAlert: true,
  });

  const handleApproveFinancialResult = () => {
    approveFinancialResult(data);
  };

  const handleDelete = async () => {
    await deleteFinancialResult(data);
    onDelete?.();
  };

  return (
    <Permissions actions={actions}>
      {({ isActionAllowed }) => (
        <UIActions limit={3}>
          <Action
            id={'approve'}
            icon={<DoneIcon />}
            label={'Approve'}
            disabled={!isActionAllowed('approve')}
            onClick={handleApproveFinancialResult}
          />
          <Action
            id={'delete'}
            icon={<DeleteIcon />}
            label={'Delete'}
            disabled={!isActionAllowed('delete')}
            onClick={handleDelete}
          />
        </UIActions>
      )}
    </Permissions>
  );
};

export default ActionsOnDraft;
